import { Box, Button, type MediumIcon, useToggle } from '@factorialco/deprecated-design-system'
import { CardDetailFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { ApproveModal } from 'modules/banking/components/CardSidepanel/_Content/_ApproveModal'
import { RejectModal } from 'modules/banking/components/CardSidepanel/_Content/_RejectModal'
import {
  BaseRequestItem,
  RequestComponentProps,
} from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/base'

const ActionButtons = ({
  card,
  onSuccess,
}: {
  card: CardDetailFragment
  onSuccess: () => void
}) => {
  const [showApproveModal, toggleApproveModal] = useToggle(false)
  const [showRejectModal, toggleRejectModal] = useToggle(false)
  return (
    <>
      <Box flexDirection="row" gap="s4">
        <Button type="negative" onClick={toggleRejectModal(true)}>
          {i18n.t('common.reject')}
        </Button>
        <Button type="positive" onClick={toggleApproveModal(true)}>
          {i18n.t('common.approve')}
        </Button>
      </Box>
      {showApproveModal && (
        <ApproveModal card={card} onClose={toggleApproveModal(false)} onSuccess={onSuccess} />
      )}
      {showRejectModal && (
        <RejectModal card={card} onClose={toggleRejectModal(false)} onSuccess={onSuccess} />
      )}
    </>
  )
}

const BankingCardRequests = ({
  request,
  index,
  compact,
  removeRequestById,
}: RequestComponentProps) => {
  const card = request.bankingCard

  if (!card) {
    return null
  }

  return (
    <>
      <BaseRequestItem
        icon={request.icon as MediumIcon}
        request={request}
        url={String(request.actionUrl)}
        index={index}
        compact={compact}
        buttons={<ActionButtons card={card} onSuccess={() => removeRequestById(request.id)} />}
      />
    </>
  )
}

export default BankingCardRequests
